'use client'

import { Button } from '../../../v3/atoms/button/button'
import Card from '../../../v3/atoms/card/card'
import s from './load-more-articles.module.css'
import { format } from 'date-fns'
import { useLoadMore } from '@/hooks/use-load-more'
import { CardGrid } from '@/components/v3/atoms/card-grid/card-grid'
import React from 'react'
import { Prisma } from '@prisma/client'

type Props = {
  articles: Prisma.articlesGetPayload<{
    select: {
      id: true
      hero_image_ref: {
        select: {
          url: true
          alt: true
        }
      }
      path: true
      title: true
      published_date: true
      article_subcategories: {
        select: {
          name: true
          slug: true
        }
      }
      article_categories: {
        select: {
          name: true
          slug: true
        }
      }
    }
  }>[]
  hasMoreArticles?: boolean
  totalCount?: number
  exploreMore?: boolean
  googleAd?: React.ReactNode
  headingLevel?: 'h2' | 'h3' | 'h4'
}

/**
 * @param hasMoreArticles - used when articles are fetched partially
 * @param totalCount - used when all articles are fetched at once
 */
export const LoadMoreArticles = ({
  articles,
  hasMoreArticles,
  totalCount,
  exploreMore,
  googleAd,
  headingLevel,
}: Props) => {
  const { loadMore } = useLoadMore()

  // Refactor this to use the count and take values
  const hasNextPage = totalCount
    ? totalCount > articles.length
    : hasMoreArticles

  return (
    <div className={s.wrapper}>
      <CardGrid>
        {articles.map((article, idx) => {
          return (
            <React.Fragment key={article.id}>
              {idx === 3 && googleAd ? googleAd : null}
              <Card
                imageUrl={article.hero_image_ref?.url!}
                imageAlt={article.hero_image_ref?.alt!}
                path={article.path!}
                header={article.title!}
                date={format(article.published_date!, 'dd.MM.yyyy')}
                itemId={article.id}
                category={
                  article.article_subcategories?.name! ||
                  article.article_categories?.name!
                }
                type="Article"
                size="Medium"
                headingLevel={headingLevel}
              />
            </React.Fragment>
          )
        })}
      </CardGrid>

      {hasNextPage && (
        <div className={s.buttonWrapper}>
          <Button onClick={loadMore}>Load More</Button>
        </div>
      )}

      {exploreMore && (
        <div className={s.buttonWrapper}>
          <Button
            href={`/${articles[0].article_categories?.slug}/${articles[0].article_subcategories?.slug}`}
          >
            More {`${articles[0].article_subcategories?.name}`}
          </Button>
        </div>
      )}
    </div>
  )
}
